import React, { useState } from "react";
import { toast } from "react-toastify";
import Tooltip from "@tippyjs/react";
import TemplateCopyService from "../../../services/contract/templateCopyService";

// Checkbox on the contract details to flag a contract as a Template.
// A Template can be copied into new contracts but can never be approved or activated.
function TemplateCheckbox({ contractId, isTemplate, onChange, disabled, hidden }) {
  const [saving, setSaving] = useState(false);

  const handleToggle = (e) => {
    const checked = e.target.checked;
    setSaving(true);
    TemplateCopyService.setTemplate(contractId, checked)
      .then((response) => {
        if (response.data.success === 1) {
          onChange(!!response.data.is_template);
          toast.success(
            checked
              ? "Contract marked as Template"
              : "Contract is no longer a Template"
          );
        } else {
          toast.error(response.data.error || "Unable to update Template flag");
        }
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.error || "Unable to update Template flag"
        );
      })
      .finally(() => setSaving(false));
  };

  if (hidden) return null;

  return (
    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
      <div className="col-lg-12 mt-4">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="contract_is_template"
            checked={!!isTemplate}
            disabled={disabled || saving}
            onChange={handleToggle}
          />
          <label className=" col-form-label py-0" htmlFor="contract_is_template">
            Template{" "}<Tooltip content="Mark this contract as a Template. A Template can be copied into new contracts but cannot be approved or activated."><i className="fa fa-light fa-circle-info"></i></Tooltip>
          </label>
        </div>
      </div>
    </div>
  );
}

export default TemplateCheckbox;
